// extracted by mini-css-extract-plugin
export default {"container":"UaU5tD","isCenterAlignment":"GsapDV","title":"o66BgN","isRightAlignment":"tQHdH_"};